<template>
    <div class="exchange-container flex-layout-v" v-if="content">
        <div class="exchange-container-top flex-layout-v flex-justify-center flex-item-center">
            <div class="exchange-container-top-content flex-layout-v flex-item-center">
                <div class="exchange-container-top-content-level">{{ currLevel }}专享</div>
                <div class="exchange-container-top-content-amount f-26-bold text-layout-center">
                    {{ title }}
                </div>
                <div class="exchange-container-top-content-desc f-16 text-layout-center">
                    {{ desc }}
                </div>
                <div
                    :class="getBtnTxtStyle()"
                    class="exchange-container-top-content-btn f-16-bold text-layout-center"
                    @click="onAwardClick()"
                >
                    {{ btnTxt }}
                </div>
            </div>
        </div>

        <div v-if="content" class="exchange-container-center">
            <div class="exchange-container-center-content flex-layout-h flex-justify-space">
                <div class="exchange-container-center-content-topvalue f-16-bold">活力值</div>
                <div class="exchange-container-center-content-topvalue f-16-bold">
                    可领{{ name }}
                </div>
            </div>
            <div
                v-for="(item, index) in content.awardList"
                :key="index"
                class="
                    exchange-container-center-content
                    flex-layout-h flex-justify-space flex-item-center
                "
                :class="rowClassObject(item, index)"
            >
                <div class="exchange-container-center-content-bottomvalue f-14">
                    {{ item.level }}（{{ item.requiredScore }}活力值）
                </div>

                <div class="flex-layout-h flex-justify-center flex-item-center">
                    <div
                        class="exchange-container-center-content-tips f-10-bold"
                        v-if="content.currentAwardKey === item.awardKey"
                    >
                        当前可享
                    </div>
                    <div class="exchange-container-center-content-bottomvalue f-14">
                        {{ couponAwardText(item) }}
                    </div>
                </div>
            </div>
            <div class="exchange-container-center-activebanner" v-if="bannerVisible">
                <ActiveValueBanner
                    :visible.sync="bannerVisible"
                    :activeValueObj="activeValueObj"
                    @show-popup="showPopup"
                />
            </div>
            <div class="exchange-container-center-line"></div>
        </div>

        <div class="exchange-container-bottom">
            <div class="exchange-container-bottom-tips f-16-bold">温馨提示</div>
            <div class="exchange-container-bottom-desc f-13" @click="toUserCoupon">
                <div style="color: #3ca5e2; font-weight: bold">{{ jumpText }}</div>
                <div v-for="tip in tips" :key="tip">{{ tip }}</div>
            </div>
        </div>

        <Dialog
            :show="showActivateDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupActivating"
            @continueBtn="continueActivating"
        />
        <Dialog1
            :show="showUpgradeDialog"
            title="做任务可以增加活力值哦！"
            lefttxt="再看看"
            righttxt="去做任务"
            @giveupBtn="giveupTask"
            @continueBtn="doSomeTask"
        />
        <Dialog2
            :show="showOverdueDialog"
            title="对不起，您当前存在逾期，请先完成还款。"
            lefttxt="再看看"
            righttxt="去还款"
            @giveupBtn="giveupToRepay"
            @continueBtn="doSomeRepay"
        />
        <tabPopup v-if="showTabPopup" :sourcePath="pathSource" @OnConfirmClick="tabPopupConfirm" />
        <revicePopup
            v-if="showReceiveDialog"
            popTit="半年可领一张券"
            :popContent="popupText"
            leftButnText="重新选择"
            rightButnText="确认领取"
            @OnLeftButnClick="giveUpReceiving"
            @OnRightButnClick="receiveXfzkq"
        />
        <TaskListPopup
            :visible.sync="popupVisible"
            :taskListInfo="taskListInfo"
            :scoreInfoData="scoreInfo"
            @OnOpenLinkClick="handleOpenLinkClick"
            @OnCloseTaskListPop="handleCloseTaskListPop"
            @OnClickNoticeType="handleClickNoticeType"
            @OnMarketTipClick="handleMarketTipClick"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import homemixin from '@common/js/mixin';
import appBridge from '@/common/util/appBridge';
import Dialog from '../../componets/birthday/homeDialog';
import Dialog1 from '../../componets/birthday/homeDialog';
import Dialog2 from '../../componets/birthday/homeDialog';
import tabPopup from '../../componets/upgradePopup/growthTabPopup';
import ActiveValueBanner from '../../componets/benefit_exchange/ActiveValueBanner';
import TaskListPopup from '../../componets/taskListPopup/TaskListPopup.vue';
import revicePopup from '../../componets/basicPopup/index.vue';

const couponTextMap = {
    0: '免息券',
    1: '还款券',
    6: '息费折扣券',
    14: '话费券'
};

const receiveModeMap = {
    1: '仅领1次',
    2: '每月领1次',
    3: '每半年领1次'
};

const buttomTextMap = {
    0: '去使用免息券 >',
    1: '去使用还款券 >',
    6: '去使用息费折扣券 >',
    14: '去充值话费 >'
};
export default {
    name: 'benefit-exchange',
    components: {
        Dialog,
        Dialog1,
        Dialog2,
        tabPopup,
        revicePopup,
        ActiveValueBanner,
        TaskListPopup
    },
    mixins: [homemixin],
    data() {
        return {
            showActivateDialog: false,
            showUpgradeDialog: false,
            showOverdueDialog: false,
            showReceiveDialog: false,
            showTabPopup: false,
            content: null,
            scoreInfo: {},
            type: -1,
            ksdf: 0,
            pathSource: '',
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '权益兑换',
                    color: '#000000'
                },
                rightView: [
                    {
                        action: 'custom',
                        text: '领取记录',
                        color: '#3CA5E2',
                        callback: this.couponRecord
                    }
                ]
            },
            popupVisible: false,
            taskListInfo: {}
        };
    },
    computed: {
        name() {
            const awardType = this.content.headerAward.awardType;
            return couponTextMap[awardType];
        },
        currLevel() {
            return this.content.currentLevel || '';
        },
        btnTxt() {
            return this.content.headerAward.buttonText || '';
        },
        desc() {
            return this.content.headerAward.desc || '';
        },
        title() {
            return this.content.headerAward.title || '';
        },
        jumpText() {
            const awardType = this.content.headerAward.awardType;
            return buttomTextMap[awardType];
        },
        tips() {
            return this.content.tips || [];
        },
        couponText() {
            return couponTextMap[this.type] || '';
        },
        page() {
            return `super-等级权益-${this.couponText}详情页`;
        },
        param() {
            return this.content.isOldCustomer ? `${this.content.score}` : '-1';
        },
        param1() {
            return this.content.isOldCustomer ? `${this.content.allScore}` : '-1';
        },
        activeValueObj() {
            console.log(this.content);
            const { score, taskGuideInfo, allScore, isOldCustomer } = this.content;
            if (taskGuideInfo) {
                return { score, allScore, isOldCustomer, ...taskGuideInfo };
            } else {
                return null;
            }
        },
        bannerVisible() {
            return this.activeValueObj === null ? false : true;
        },
        popupText() {
            return this.content.popupText;
        }
    },
    created() {
        this.type = parseInt(this.$route.query.type, 10);
        this.ksdf = parseInt(this.$route.query.ksdf, 10);
        this.pathSource = this.$route.query.source;
        console.log('pathSource: ', this.pathSource);
        this.titleBar.titleView.text = `${this.couponText}`;

        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }

        if (this.type !== -1) {
            this.getCouponInfo();
        }
        this.requestAward = this.debounce2(
            () => {
                this.requestAwardApi();
            },
            100,
            true
        );
    },
    methods: {
        rowClassObject(item, index) {
            return {
                'exchange-container-center-contentchecked':
                    this.getAnimIndex() === index && this.ksdf
            };
        },
        trackerPointByType(isClick) {
            const eventIdMap = {
                免息券: 'h5_ACT_grade_freeCoupon',
                还款券: 'h5_ACT_grade_repayment',
                息费折扣券: 'h5_ACT_grade_xfzkqy',
                话费券: 'h5_ACT_grade_phone'
            };
            const tgtEventId = eventIdMap[this.couponText] || '';
            const tgtName = `h5-ACT-等级权益-${this.couponText}详情页`;

            if (this.couponText === '息费折扣券') {
                this.POINT(isClick ? 'h5_clk' : 'h5_element_imp', {
                    tgt_event_id: tgtEventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.param,
                    param1: this.param1,
                    param2: this.title,
                    param3: this.desc,
                    param4: this.btnTxt,
                    param5: this.$route.query.source
                });
            } else {
                this.POINT(isClick ? 'h5_clk' : 'h5_element_imp', {
                    tgt_event_id: tgtEventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.param,
                    param1: this.param1,
                    param2: this.btnTxt,
                    param3: this.$route.query.source,
                    param4: this.title,
                    param5: this.desc
                });
            }
        },
        giveupActivating() {
            this.showActivateDialog = false;
            this.trackActivationDialog(true, '再看看');
        },
        continueActivating() {
            this.showActivateDialog = false;
            this.trackActivationDialog(true, '去首页');
            this.goHome();
        },
        async getCouponInfo() {
            const apiUrlMap = {
                免息券: '/growth/award/getFreeInterestBenefitPageInfo',
                还款券: '/growth/award/getRepaymentBenefitPageInfo',
                息费折扣券: '/growth/award/getzkqbenefitpageinfo',
                话费券: '/growth/award/getPhoneBenefitPageInfo'
            };
            const apiUrl = apiUrlMap[this.couponText];
            let res = null;
            if (this.type === 0) {
                // 免息
                res = await this.$http.getFreeInterestBenefitPageInfo({});
            } else if (this.type === 1) {
                // 还款
                res = await this.$http.getRepaymentBenefitPageInfo({});
            } else if (this.type === 14) {
                // 话费
                res = await this.$http.getPhoneBenefitPageInfo({});
            } else if (this.type === 6) {
                // 息费
                res = await this.$http.getzkqbenefitpageinfo({});
            }
            if (res && res.Result === 200) {
                this.content = res.Content;
                this.scoreInfo = {
                    allScore: this.content.allScore,
                    totalScore: this.content.score
                };
                this.trackerPointByType(false);
            } else {
                this.trackError({
                    errorText: res.ResultMessage,
                    errorCode: res.Result,
                    apiUrl
                });
                this.$toast(res && res.ResultMessage);
            }
        },
        receiveModeDesc(mode) {
            return receiveModeMap[mode] || '';
        },
        getBtnTxtStyle() {
            if (!this.content) {
                return;
            }
            if (
                this.couponText === '息费折扣券' &&
                [22, 30].includes(this.content.headerAward.awardStatus)
            ) {
                return 'exchange-container-top-content-btnwhite';
            }
            if (this.content.headerAward.awardStatus === 20) {
                return 'exchange-container-top-content-btngray';
            }
            if (
                this.content.headerAward.awardStatus === 22 &&
                this.content.headerAward.receiveMode === 2
            ) {
                return 'exchange-container-top-content-btngray';
            }
        },
        getAnimIndex() {
            if (!this.content) {
                return;
            }
            let itemList = this.content.awardList;
            let index = 0;
            for (let i = 0; i < itemList.length; i++) {
                if (itemList[i].awardKey === this.content.currentAwardKey) {
                    index = i + 1;
                    break;
                }
            }
            return index;
        },
        async requestAwardApi() {
            let res = {};
            let paramApi = '';
            if (this.type === 0) {
                // 免息
                paramApi = '/growth/award/receiveFreeInterestBenefit';
                res = await this.$http.receiveFreeInterestBenefit({
                    awardKey: this.content.currentAwardKey
                });
            } else if (this.type === 1) {
                // 还款
                paramApi = '/growth/award/receiveRepaymentBenefit';
                res = await this.$http.receiveRepaymentBenefit({
                    awardKey: this.content.currentAwardKey
                });
            } else if (this.type === 14) {
                // 话费
                paramApi = '/growth/award/receivePhoneBenefit';
                res = await this.$http.receivePhoneBenefit({
                    awardKey: this.content.currentAwardKey
                });
            } else if (this.type === 6) {
                // 息费
                paramApi = '/growth/award/receivezkqbenefit';
                res = await this.$http.receivezkqbenefit({
                    awardKey: this.content.currentAwardKey
                });
                this.trackReceivingDialog(true, '确认领取');
            }
            if (res.Result === 200) {
                this.$toast(res.ResultMessage);
                this.getCouponInfo();
                if (
                    this.$route.query.source === 'fbyqlb' ||
                    this.$route.query.source === 'hqqryqlb'
                ) {
                    setTimeout(() => {
                        this.isShowTabPopup();
                    }, 2000);
                }
            } else {
                if (res.Result === 40718 || res.Result === 40714 || res.Result === 40801) {
                    this.$toast(res.ResultMessage);
                } else if (res.Result === 40719) {
                    this.showOverdueDialog = true;
                    this.overDueDailogTrack(false, '');
                } else {
                    this.$toast('领取失败，请重试');
                }
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: `super-${this.name}页面`,
                    ret_code: res.Result,
                    param: res.ResultMessage,
                    param1: paramApi,
                    param2: this.$route.query.source
                });
            }
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.overDueDailogTrack(true, '再看看');
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.overDueDailogTrack(true, '去还款');
            this.openLink('ppdloanapp://repayment/index');
        },
        receiveXfzkq() {
            this.showReceiveDialog = false;
            this.requestAward();
        },
        giveUpReceiving() {
            this.showReceiveDialog = false;
            this.trackReceivingDialog(true, '再看看');
        },
        overDueDailogTrack(isClick = false, text = '') {
            const event = isClick ? 'h5_clk' : 'h5_element_imp';
            const eventIdMap = {
                免息券: 'h5_ACT_grade_freeCoupon_yuqibox',
                还款券: 'h5_ACT_grade_repayment_yuqibox',
                息费折扣券: 'h5_ACT_grade_xfzkqy_yuqibox',
                话费券: 'h5_ACT_grade_phone_yuqibox'
            };
            const eventId = eventIdMap[this.couponText];
            const tgtName = `h5-ACT-等级权益-${this.couponText}详情页-逾期提示弹窗`;

            if (this.couponText === '息费折扣券') {
                this.POINT(event, {
                    tgt_event_id: eventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.param,
                    param1: this.param1,
                    param2: text
                });
            } else {
                this.POINT(event, {
                    tgt_event_id: eventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.content.score,
                    param1: text
                });
            }
        },
        onAwardClick() {
            this.trackerPointByType(true);
            if (this.content.headerAward.awardStatus === 0) {
                if (this.content.isOldCustomer) {
                    // 升级弹窗
                    this.showUpgradeDialog = true;
                    this.trackUpgradeDialog();
                } else {
                    // 激活弹窗
                    this.showActivateDialog = true;
                    this.trackActivationDialog();
                }
                return;
            }
            if (
                this.content.headerAward.receiveMode === 1 &&
                this.content.headerAward.awardStatus === 22
            ) {
                this.showUpgradeDialog = true;
                return;
            }
            if (this.content.headerAward.awardStatus === 10) {
                if (this.couponText === '息费折扣券') {
                    this.showReceiveDialog = true;
                    this.trackReceivingDialog();
                } else {
                    this.requestAward();
                }
            }
            if ([20, 21].includes(this.content.headerAward.awardStatus)) {
                if (this.content.headerAward.redirectUrl) {
                    this.openLink(this.content.headerAward.redirectUrl);
                }
            }
        },
        doSomeTask() {
            localStorage.setItem('updata', 'true');
            this.trackUpgradeDialog(true, '去做任务');
            this.goClose();
        },
        giveupTask() {
            this.showUpgradeDialog = false;
            this.trackUpgradeDialog(true, '再看看');
        },
        toUserCoupon() {
            if (this.couponText === '话费券') {
                this.POINT('h5_clk', {
                    page: 'super-等级权益-话费券详情页',
                    tgt_name: 'h5-ACT-等级权益-话费券详情页-温馨提示去充值话费',
                    tgt_event_id: 'h5_ACT_grade_phoneUrl',
                    param: this.content.isOldCustomer ? this.content.score : '-1',
                    param1: this.content.isOldCustomer ? this.content.allScore : '-1'
                });
                this.openLink(
                    `${window.location.protocol}//userlife.ppdai.com/latest/#/telephone`
                );
            } else if (this.couponText === '还款券') {
                this.POINT('h5_clk', {
                    page: 'super-等级权益-话费券详情页',
                    tgt_name: 'h5-ACT-等级权益-还款券详情页-温馨提示去使用按钮',
                    tgt_event_id: 'h5_ACT_grade_repayment_use',
                    param: this.content.isOldCustomer ? this.content.score : '-1',
                    param1: this.content.isOldCustomer ? this.content.allScore : '-1'
                });
                this.openLink(
                    `${window.location.protocol}//loanweb.ppdai.com/web/account/coupon/dist/index.html?source=privilege`
                );
            } else if (this.couponText === '免息券') {
                this.POINT('h5_clk', {
                    page: 'super-等级权益-免息券详情页',
                    tgt_name: 'h5-ACT-等级权益-免息券详情页-温馨提示去使用按钮',
                    tgt_event_id: 'h5_ACT_grade_freeCoupon_use',
                    param: this.content.isOldCustomer ? this.content.score : '-1',
                    param1: this.content.isOldCustomer ? this.content.allScore : '-1'
                });
                this.openLink(
                    `${window.location.protocol}//loanweb.ppdai.com/web/account/coupon/dist/index.html?source=privilege`
                );
            } else if (this.couponText === '息费折扣券') {
                this.POINT('h5_clk', {
                    page: 'super-等级权益-免息券详情页',
                    tgt_name: 'h5-ACT-等级权益-免息券详情页-温馨提示去使用按钮',
                    tgt_event_id: 'h5_ACT_grade_freeCoupon_use',
                    param: this.content.isOldCustomer ? this.content.score : '-1',
                    param1: this.content.isOldCustomer ? this.content.allScore : '-1'
                });
                this.openLink(
                    `${window.location.protocol}//loanweb.ppdai.com/web/account/coupon/dist/index.html?source=privilege`
                );
            }
        },
        trackReceivingDialog(isClick = false, text = '') {
            const event = isClick ? 'h5_clk' : 'h5_element_imp';
            const eventIdMap = {
                息费折扣券: 'h5_ACT_grade_xfzkqy_qrlqbox'
            };
            const eventId = eventIdMap[this.couponText];
            const tgtName = `h5-ACT-等级权益-${this.couponText}页-确认领券弹窗`;
            let params = {
                tgt_event_id: eventId,
                tgt_name: tgtName,
                page: this.page,
                param: this.param,
                param1: this.param1,
                param2: isClick ? text : this.popupText
            };
            isClick && (params.param3 = this.popupText);
            this.POINT(event, params);
        },
        trackActivationDialog(isClick, text) {
            if (this.couponText === '息费折扣券') {
                const event = isClick ? 'h5_clk' : 'h5_element_imp';
                const eventIdMap = {
                    息费折扣券: 'h5_ACT_grade_freeCoupon_jihuobox'
                };
                const eventId = eventIdMap[this.couponText];
                const tgtName = `h5-ACT-等级权益-${this.couponText}页-未激活提示弹窗`;
                this.POINT(event, {
                    tgt_event_id: eventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.param,
                    param1: this.param1,
                    param2: text
                });
            }
        },
        trackUpgradeDialog(isClick, text) {
            if (this.couponText === '息费折扣券') {
                const event = isClick ? 'h5_clk' : 'h5_element_imp';
                const eventIdMap = {
                    息费折扣券: 'h5_ACT_grade_xfzkqy_upBox'
                };
                const eventId = eventIdMap[this.couponText];
                const tgtName = `h5-ACT-等级权益-${this.couponText}页-去升级提示弹窗`;
                this.POINT(event, {
                    tgt_event_id: eventId,
                    tgt_name: tgtName,
                    page: this.page,
                    param: this.param,
                    param1: this.param1,
                    param2: text
                });
            }
        },
        trackError({ errorText = '', errorCode = 0, apiUrl = '' }) {
            this.POINT('app_auth', {
                auth_tgt: 'super_privilege_errorMsg',
                auth_tgt_name: 'super-成长权益-报错集合',
                param: errorText,
                param1: apiUrl,
                param2: this.$route.query.source,
                ret_code: errorCode
            });
        },
        tabPopupConfirm() {
            const eventIdMap = {
                免息券: 'h5_ACT_grade_freeCoupon_tabydbox',
                还款券: 'h5_ACT_grade_repayment_tabydbox',
                息费折扣券: 'h5_ACT_grade_xfzkqy_tabydbox'
            };
            const tgtEventId = eventIdMap[this.couponText] || '';
            this.POINT('h5_clk', {
                page: `super-等级权益-${this.couponText}页`,
                tgt_name: `h5-ACT-等级权益-${this.couponText}页-tab引导弹窗`,
                tgt_event_id: tgtEventId,
                param: this.content.isOldCustomer ? this.content.score : '-1',
                param1: this.content.isOldCustomer ? this.content.allScore : '-1',
                param2: this.$route.query.source,
                param3: '知道了'
            });
            this.showTabPopup = false;
            this.goClose();
        },
        async isShowTabPopup() {
            const { Result, Content } = await this.$http.isShowTabPopUp({
                awardKey: this.content.currentAwardKey
            });
            if (Result === 200) {
                console.log('isShowTabPopup', Content);
                if (Content.showPopup === 1) {
                    this.showTabPopup = true;
                    const eventIdMap = {
                        免息券: 'h5_ACT_grade_freeCoupon_tabydbox',
                        还款券: 'h5_ACT_grade_repayment_tabydbox',
                        息费折扣券: 'h5_ACT_grade_xfzkqy_tabydbox'
                    };
                    const tgtEventId = eventIdMap[this.couponText] || '';
                    this.POINT('h5_element_imp', {
                        page: `super-等级权益-${this.couponText}页`,
                        tgt_name: `h5-ACT-等级权益-${this.couponText}页-tab引导弹窗`,
                        tgt_event_id: tgtEventId,
                        param: this.content.isOldCustomer ? this.content.score : '-1',
                        param1: this.content.isOldCustomer ? this.content.allScore : '-1',
                        param2: this.$route.query.source
                    });
                }
            }
        },
        couponAwardText(item) {
            const receiveModeDesc = this.receiveModeDesc(item.receiveMode);
            if (this.couponText === '息费折扣券') {
                return `${item.couponDiscount / 10}折(${receiveModeDesc})`;
            } else {
                return `${item.couponAmount / 100}元(${receiveModeDesc})`;
            }
        },
        async showPopup() {
            await this.taskList();
        },
        // 任务列表弹窗
        async taskList() {
            const { Result, Content, ResultMessage } = await this.$http.getTaskListV2({});
            if (Result === 200 && Content) {
                this.popupVisible = true;
                this.taskListInfo = Content;
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getTaskListV2',
                    param2: this.$route.query.source
                });
            }
        },
        handleOpenLinkClick(value) {
            this.openLink(value);
        },
        handleCloseTaskListPop() {
            this.popupVisible = false;
        },
        handleClickNoticeType(value) {
            this.openLink(value);
        },
        // 营销任务
        async handleMarketTipClick(itemVlaue) {
            if (
                itemVlaue.taskHandler === 'LLHDongTaskHandler' ||
                itemVlaue.taskHandler === 'JBSLLHDongTaskHandler'
            ) {
                const { Result } = await this.$http.notifyLLHDongTaskDone({
                    taskId: itemVlaue.taskId
                });
                if (Result === 200) {
                    if (itemVlaue.redirectUrl) {
                        this.openLink(itemVlaue.redirectUrl);
                    }
                }
            } else {
                if (itemVlaue.redirectUrl) {
                    this.openLink(itemVlaue.redirectUrl);
                }
            }
        },
        couponRecord() {
            let pointParams = {
                score: this.content ? this.content.score : '',
                allScore: this.content ? this.content.allScore : ''
            };
            let encodeStr = encodeURIComponent(JSON.stringify(pointParams));
            this.openLink(
                `${window.location.protocol}//growthhome.ppdai.com/welfareRecord?sence=quan&type=${this.type}&pointParams=${encodeStr}`
            );
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';
.exchange-container {
    position: relative;
    &-top {
        width: 375px;
        height: 233px;
        position: relative;
        background: rgba(235, 246, 255, 1);
        &-content {
            position: relative;
            .backgroundImage(375px, 193px, '~@assets/img/coupon-card-bg@2x.png');
            &-level {
                margin-left: 240px;
                margin-top: 22px;
                color: #7b4d14;
                font-size: 12px;
            }
            &-amount {
                margin-top: 14px;
                color: white;
            }
            &-desc {
                margin-top: 6px;
                color: white;
            }
            &-btn {
                margin-top: 20px;
                color: #5e8ec8;
                padding: 0 25px;
                font-size: 16px;
                // font-family: 'fzlt_bold';
                font-weight: bold;
                line-height: 32px;
                height: 32px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 3px 0px rgba(40, 116, 171, 0.35);
                border-radius: 16px;
            }
            &-btnwhite {
                color: #ffffff;
                background: rgba(255, 255, 255, 0.35);
                box-shadow: none;
            }
            &-btngray {
                color: #ffffff;
                background: rgba(40, 116, 171, 0.35);
            }
        }
    }
    &-center {
        background: white;
        padding: 10px 10px 0 10px;
        &-content {
            position: relative;
            height: 24px;
            margin-top: 15px;
            padding: 0 8px;
            border-radius: 2px;
            &-topvalue {
                color: rgba(99, 115, 135, 1);
            }
            &-bottomvalue {
                color: rgba(99, 115, 135, 1);
            }
            &-tips {
                padding: 2px 6px;
                margin-top: -3px;
                margin-right: 5px;
                background: rgba(255, 235, 193, 1);
                border-radius: 2px;
                text-align: center;
                border: 1px solid rgba(221, 186, 117, 1);
                color: #b26200;
            }
        }
        &-contentchecked {
            animation: 1s pulse 2 ease-in-out;
        }
        &-activebanner {
            margin-top: 30px;
        }
        &-line {
            margin: 24px auto 0;
            width: 339px;
            height: 1px;
            background: #d5d9de;
        }
    }
    &-bottom {
        padding: 15px 18px;
        &-tips {
            color: #002b3c;
        }
        &-desc {
            margin-top: 10px;
            color: #637387;
            line-height: 20px;
        }
    }
    .exchange-container-bottom {
        margin-bottom: 25px;
    }
    @keyframes pulse {
        from {
            background: rgba(255, 235, 193, 1);
        }
        50% {
            background: white;
        }
        to {
            background: rgba(255, 235, 193, 1);
        }
    }
}
</style>
